import React, { useEffect, useState } from "react";
import { Table, Tooltip } from "antd";
import styles from "./GroupedCapacityPlaningClients.local.scss";
import styles2 from "./../../DynamicTable/DynamicTable.local.scss";
import _ from "i18n";
import {
  getTimeByDurationFormat,
  resolveNullability,
  getCollaboratorRoles
} from "Utils";
import { connect } from "react-redux";
import {
  fetchGroupedCapacityPlaningClients,
  exportCapacityDossierSheet
} from "Thunks";
import NotFoundV2 from "../../NotFound/NotFoundV2";
import {
  setDynamicTableFilterYear,
  initBudgetSettingClient,
  setBudgetSettingClient
} from "Actions";
import GroupedCapacityPlaningClientsFilter from "./GroupedCapacityPlaningClientsFilter";
import classNames from "classnames";
import { BudgetIcon } from "../../Common/Icons";
import { push } from "react-router-redux";
import { formatAmount } from "../../../utils";

const GroupedCapacityPlaningClients = props => {
  const {
    date,
    dispatch,
    arrivalDate,
    selectedYear,
    onAnalyseDateChange,
    grouped: { fetching, fetched, data, error },
    collaboratorName,
    exportFetching
  } = props;
  const filterFormState = useState(false);
  const setFilterFormIsVisible = filterFormState[1];
  const year = date ? date.format("Y") : new Date().getFullYear().toString();

  const handleRedirectBudgetSetting = ({ id, name, year }) => {
    dispatch(initBudgetSettingClient());
    dispatch(setBudgetSettingClient({ id, name }));
    dispatch(push(`/budget-setting/?name=${name}&id=${id}&year=${year}`));
  };

  const handleExportFinancialSheet = () => {
    dispatch(exportCapacityDossierSheet(collaboratorName));
  };

  const renderContent = (value, row) => {
    const obj = {
      children: (
        <span>
          <p>{resolveNullability(value)}</p>
        </span>
      ),
      props: {}
    };
    if (row["TypeAttribut"] === "TOTAL") {
      obj.props.colSpan = 0;
    }
    return obj;
  };

  const columns = [
    {
      className: styles.column_light,
      title: _("client"),
      dataIndex: "NomClient",
      width: "17%",
      render: (value, row, index) => {
        if (row["TypeAttribut"] !== "TOTAL") {
          return (
            <div>
              {value.length > 29 ? (
                <Tooltip placement="right" title={value} mouseLeaveDelay={0}>
                  <p>{`${value.substring(0, 29)}...`}</p>
                </Tooltip>
              ) : (
                <p>{value}</p>
              )}
              <Tooltip
                placement="bottom"
                title={_("configBudget")}
                mouseLeaveDelay={0}
              >
                <div
                  onClick={() =>
                    handleRedirectBudgetSetting({
                      id: row["IdClient"],
                      name: value,
                      year: selectedYear
                    })
                  }
                >
                  <BudgetIcon color={"#3c4e64"} />
                </div>
              </Tooltip>
            </div>
          );
        }

        let obj = {
          children: (
            <span>
              <p>Total : {row["NbrFolders"]}</p>
            </span>
          ),
          props: {}
        };
        if (index === 0) {
          obj["props"]["colSpan"] = 4;
        } else if (index < 4) {
          obj["props"]["colSpan"] = 0;
        }
        return obj;
      }
    },
    {
      className: styles.column_light,
      title: _("Groupe"),
      dataIndex: "GroupeClient",
      width: "10.625%",
      render: renderContent
    },
    {
      className: styles.column_light,
      title: _("regimeVAT"),
      dataIndex: "RegimeTVA",
      width: "10.625%",
      render: renderContent
    },
    {
      className: styles.column_light,
      title: _("Cloture"),
      dataIndex: "DateCloture",
      width: "10.625%",
      render: renderContent
    },
    {
      title: _("collaborator"),
      dataIndex: "NbrCollaborators",
      width: "12.625%",
      render: (value, row) => {
        return (
          <div>
            <span>
              <p>
                {_("All")} :{" "}
                {row["TypeAttribut"] === "TOTAL"
                  ? row["NbrCollaborators"]
                  : value}{" "}
              </p>
            </span>
            <span>
              <p>{collaboratorName} </p>
            </span>
          </div>
        );
      }
    },
    {
      title: _("Role"),
      dataIndex: "Collaborator.Roles",
      width: "10.625%",
      render: (value, row) => {
        return (
          <div>
            <span>
              <p>-</p>
            </span>
            <span>
              <p>{value ? getCollaboratorRoles(value) : "-"}</p>
            </span>
          </div>
        );
      }
    },
    {
      title: _("Bud Eco"),
      dataIndex: "AllCollaborators.economicBudget",
      width: "10.625%",
      render: (value, row) => {
        return (
          <div>
            <span>
              <p>{formatAmount(value)}</p>
            </span>
            <span>
              <p>
                {formatAmount(Number(row["Collaborator"]["economicBudget"]))}
              </p>
            </span>
          </div>
        );
      }
    },
    {
      title: _("Bud total"),
      dataIndex: "AllCollaborators.SumBudget",
      width: "10.625%",
      render: (value, row) => {
        return (
          <div>
            <span>
              <p>{getTimeByDurationFormat(value)}</p>
            </span>
            <span>
              <p>{getTimeByDurationFormat(row["Collaborator"]["SumBudget"])}</p>
            </span>
          </div>
        );
      }
    },
    {
      title: _("bud BE"),
      dataIndex: "AllCollaborators.BudgetBelgique",
      width: "8.625%",
      render: (value, row) => {
        return (
          <div>
            <span>
              <p>{getTimeByDurationFormat(value)}</p>
            </span>
            <span>
              <p>
                {getTimeByDurationFormat(row["Collaborator"]["BudgetBelgique"])}
              </p>
            </span>
          </div>
        );
      }
    },
    {
      title: _("Bud MA"),
      dataIndex: "AllCollaborators.BudgetMaroc",
      width: "8.625%",
      render: (value, row) => {
        return (
          <div>
            <span>
              <p>{getTimeByDurationFormat(value)}</p>
            </span>
            <span>
              <p>
                {getTimeByDurationFormat(row["Collaborator"]["BudgetMaroc"])}
              </p>
            </span>
          </div>
        );
      }
    }
  ];

  useEffect(
    () => {
      dispatch(setDynamicTableFilterYear(year));
      dispatch(fetchGroupedCapacityPlaningClients());
    },
    [date]
  );

  const handleFilterFormIsVisible = isVisible => {
    setFilterFormIsVisible(isVisible);
  };

  return (
    <div className={styles2.resizable}>
      <div>
        <div className={classNames("ttp-tab-container")}>
          <div style={{ margin: "auto" }}>
            {/* <a
              target="_blank"
              className="btn secondary text-uppercase"
              onClick={handleExportFinancialSheet}
              style={{
                width: 100,
                height: 32,
                fontSize: 13,
                marginLeft: 0,
                boxShadow: "0px 0px 3px rgb(41 57 77 / 10%)"
              }}
            >
              {exportFetching ? (
                <img
                  width={"13%"}
                  src={"/img/icons/tail-spin-blue.svg"}
                  alt={""}
                />
              ) : (
                <img
                  width={"10%"}
                  src={"/img/icons/exportation.svg"}
                  alt={""}
                />
              )}
              {_("Export")}
            </a> */}

            <GroupedCapacityPlaningClientsFilter
              arrivalYear={arrivalDate ? arrivalDate.year() : null}
              resultCount={data && data.length > 0 ? data[0]["NbrFolders"] : 0}
              filterFormIsVisible={handleFilterFormIsVisible}
              onAnalyseDateChange={onAnalyseDateChange}
            />

            {fetching ? (
              <div className={styles2.ripple_loading}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            ) : fetched ? (
              data && data.length > 0 ? (
                <Table
                  rowKey="key"
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  className={styles.grouped_capacity_planing_table}
                  scroll={{ y: "600px" }}
                />
              ) : (
                <NotFoundV2 />
              )
            ) : (
              error && <NotFoundV2 text={error.title} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  selectedYear: state.budget.dynamicTable.filter.year,
  grouped: state.capacityPlaning.production.grouped,
  clientName: state.capacityPlaning.collaborator.filter.clientName,
  exportFetching: state.capacityPlaning.exportCapacityDossier.fetching
});

export default connect(mapStateToProps)(GroupedCapacityPlaningClients);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/GroupedCapacityPlaningClients/GroupedCapacityPlaningClients.js